import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "status-tag" }

import { i18n } from '@/i18n';

/**
 * propsの定義
 * @param orderStatusStr - 注文ステータス
 */
type Props = {
  orderStatusStr?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderStatusBadge',
  props: {
    orderStatusStr: { default: '' }
  },
  setup(__props: any) {

/**
 * 発注ステータスバッジ
 */

const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`container status-tag__container status-tag__container--${_ctx.orderStatusStr}`)
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(`container--${_ctx.orderStatusStr}`)
      }, _toDisplayString(_unref(t)(_ctx.orderStatusStr)), 3)
    ], 2)
  ]))
}
}

})